
import {
  computed,
  defineComponent,
  onMounted,
  ref,
  toRefs,
  nextTick,
  watch,
} from "vue";
import { useStore } from "vuex";
import ActivityModal from "@/views/user/modal/ActivityModal.vue";
import { IBulkDelete } from "@/interfaces/iPageModel";
import { TranslationService } from "@/core/services/TranslationService";
import { PAGINATION, PAGE_ITEMS } from "@/helpers/pagination";
import { FormatMethods } from "@/helpers/data-format";
import Datatable from "@/components/kt-datatable/KTDatatable.vue";
import { UserAPI } from "@/services/api/User.service";
import VZDeleteModal from "@/components/content/VZDeleteModal.vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import * as Yup from "yup";
import {
  IRolePermissionModel,
  IUser,
  IUserPermission,
  IUserRoleModel,
} from "@/interfaces/iUser";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import {
  userPermissionCustomPermissionTableFilters,
  userPermissionCustomPermissionTableHeaders,
  userPermissionsCustomPermissionsTableBulkDelete,
  userPermissionsUserRoleTableBulkDelete,
  userPermissionUserPermissionTableFilters,
  userPermissionUserPermissionTableHeaders,
  userPermissionUserRoleTableFilters,
  userPermissionUserRoleTableHeaders,
  userCustomPermissionsBulkDelete,
} from "../dataTableOptions";
import { hasPermission } from "@/core/services/permission.service";
import { Modal } from "bootstrap";
import { getLookups } from "@/services/api/Lookup.service";
import { IAddEditFormModel } from "@/interfaces/iAddEditFormModel";

import { hideModal } from "@/core/helpers/dom";
import VZFilter from "@/components/kt-datatable/components/VZFilter.vue";
import { IDataTableFilterOption } from "@/interfaces/iPageModel";
interface IPagination {
  page: number;
  total: number;
  rowsPerPage: number;
  search?: string;
}
import { ICurrentUser } from "@/interfaces/iCurrentUser";
import store from "@/store";
import VZMultiSelect from "@/components/modals/forms/VZMultiSelect.vue";
import { useToast } from "vue-toastification";
import { GET_SELECTED_SITES, SITE_STORE } from "@/store/userSite/types";
import { Actions } from "@/store/enums/StoreEnums";
export default defineComponent({
  name: "UserPermission",
  components: {
    Datatable,
    VZDeleteModal,
    VZFilter,
    Field,
    Form,
    ErrorMessage,
    ActivityModal,
  },
  setup() {
    const t = (key: string) => {
      return TranslationService.translate(key);
    };
    const store = useStore();
    // Access selectedSites from Vuex
    const selectedSites = computed(() => {
      const key = `${SITE_STORE}/${GET_SELECTED_SITES}`;
      return store.getters[key];
    });
    const users = ref<IUser[]>([]);
    const usersFilter = ref<IUser[]>([]);
    const usersPagination = { ...PAGINATION };

    const showDeleteDialogUserRole = ref<any>(false);
    const showDeleteDialogUserPermission = ref<any>(false);
    const defaultFilterUsers = ref();
    const hideModalRef = ref<null | HTMLElement>(null);
    const formRef = ref<null | HTMLFormElement>(null);

    const userRolesPagination = { ...PAGINATION };
    const customPermissionsToBeDeleted = ref<any>([]);
    const loadingUserRoles = ref(false);
    const defaultFilterUserRoles = ref({});
    const showSearchUserRoles = true;
    const tableDataUserRoles = ref<any[]>([]);
    const selectedForActionUserRoles = ref<Partial<IUserRoleModel>>({});
    const localPreferenceUserRoles = ref({});
    const bulkDeleteUserRoles = ref<IBulkDelete>(
      userPermissionsUserRoleTableBulkDelete()
    );
    const bulkDeleteCustomUser = ref<IBulkDelete>(
      userCustomPermissionsBulkDelete()
    );
    const tableHeaderUserRoles = ref(userPermissionUserRoleTableHeaders());
    const tableFilterUserRoles = ref(userPermissionUserRoleTableFilters());

    const loadingUserPermissions = ref(false);
    let userPermissionsPagination = { ...PAGINATION };
    const defaultFilterUserPermissions = ref({});
    const showSearchUserPermissions = true;
    const tableDataUserPermissions = ref<IUserPermission[]>([]);
    const selectedForActionUserPermissions = ref<Partial<IUserPermission>>({});
    const localPreferenceUserPermissions = ref({});
    const bulkDeleteUserPermissions = ref<IBulkDelete>();
    const selectedUserPermissions = ref([]);
    const selectedUserRoles = ref([]);
    const openToggel = ref(false);
    const tableHeaderUserPermissions = ref(
      userPermissionUserPermissionTableHeaders()
    );
    const tableFilterUserPermissions = ref(
      userPermissionUserPermissionTableFilters()
    );
    const formDataRolePermissions = ref({});

    const userPermissionsRoleBase = ref<any[]>([]);

    const rolePermissionsPagination = { ...PAGINATION };
    const loadingRolePermissions = ref(false);
    const defaultFilterRolePermissions = ref({});
    const showSearchRolePermissions = true;
    const tableDataRolePermissions = ref<IUserPermission[]>([]);
    const selectedForActionRolePermissions = ref<Partial<IRolePermissionModel>>(
      {}
    );
    const loading = ref<boolean>(false);
    const localPreferenceRolePermissions = ref({});
    const bulkDeleteRolePermissions = ref<IBulkDelete>(
      userPermissionsCustomPermissionsTableBulkDelete()
    );
    const tableHeaderRolePermissions = ref(
      userPermissionCustomPermissionTableHeaders()
    );
    const tableFilterRolePermissions = ref(
      userPermissionCustomPermissionTableFilters()
    );

    let targetDataUserPermission = ref<any>({});

    const permissionIds = ref<any>([]);
    let options: { label: any; value: string }[] = [];
    let siteOptions: { label: any; value: string }[] = [];
    let roleOptions: { label: any; value: string }[] = [];
    const usersSearchTerm = ref<any>();

    let permissionGroups = ref<any>([]);

    let selectedUserId = ref<number>();
    let selectedSiteId = ref<number>();

    let userIds: number[] = [];
    let userRoleIds: number[] = [];
    let siteIds: number[] = [];
    const toast = useToast();
    const deleteMsgOfuserRoleSite = t("common.deleteMsgOfuserRoleSite");
    const deleteMsgOfCustomPermission = t("common.deleteMsgOfCustomPermission");
    const addMsgOfCustomPermission = t("common.addMsgOfCustomPermission");
    const format = computed(() => {
      return FormatMethods;
    });
    const currentUser = computed(() => {
      return store.getters.currentUser as ICurrentUser;
    });
    const formDataUserRoles = ref<any>({});
    const formDataUserPermissions = ref<any>({});
    const { page, total, rowsPerPage } = PAGINATION;
    const pagination = ref<IPagination>({
      page: page,
      total: total,
      rowsPerPage: rowsPerPage,
    });
    const activeFilter = ref<number>(0);
    const localPreference = ref({});
    const selectUserName = ref<string>();
    const customPermisionsList = ref<any>([]);
    const PAGE_ITEM = ref<number[]>(PAGE_ITEMS);
    const tableFilter = ref<Array<IDataTableFilterOption>>([
      {
        key: "userIds",
        label: TranslationService.translate("common.users"),
        type: "lookup",
        attrs: {
          mode: "tags",
        }, //
        url: "security/filter/USERS",
        textKey: "text",
        valueKey: "value",
      },
    ]);

    const loadingCounter = ref(0);
    const pageIsLoading = computed(() => loadingCounter.value > 0);

    const startLoading = () => {
      loadingCounter.value++;
    };

    const stopLoading = () => {
      loadingCounter.value = Math.max(0, loadingCounter.value - 1);
    };

    watch(pageIsLoading, (isLoading) => {
      if (isLoading) {
        store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");
      } else {
        store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
      }
    });

    onMounted(async () => {
      try {
        setCurrentPageBreadcrumbs("User Permissions", [
          "Home",
          "User Permissions",
        ]);
        startLoading();

        const filterOptions = await Promise.all([
          getLookups("site/filter/SITES"),
          getLookups("security/filter/USERS"),
          getLookups("security/filter/ROLES"),
        ]);
        filterOptions[0].map((data) => {
          siteOptions.push({
            label: data.text,
            value: data.value,
          });
        });
        filterOptions[1].map((data) => {
          options.push({
            label: data.text,
            value: data.value,
          });
        });
        filterOptions[2].map((data) => {
          roleOptions.push({
            label: data.text,
            value: data.value,
          });
        });
        await UserAPI.getInstance()
          .getPermissionGroups()
          .then((res) => {
            permissionGroups.value = [...res];
          })
          .catch((err) => {
            console.error(err);
          });
        // await getUsers({ page: 0, size: usersPagination.rowsPerPage });
      } catch (e) {
        console.log(e);
      } finally {
        stopLoading();
      }
    });

    const updatePermissionForRole = async (permissionId, checked?) => {
      if (permissionIds.value.filter((obj) => obj == permissionId).length > 0) {
        permissionIds.value = permissionIds.value.filter(
          (obj) => obj !== permissionId
        );
      } else {
        const cusPermissionId = customPermisionsList.value.filter(
          (customPer) => customPer.webId == permissionId
        )[0]?.user_permission_id;
        if (cusPermissionId != null)
          customPermissionsToBeDeleted.value.push(cusPermissionId);
        else permissionIds.value.push(permissionId);
      }
    };

    const loadUserRoleData = async (id, element?) => {
      startLoading();
      try {
        selectedUserId.value = id;
        await Promise.all([
          queryUpdateUserRoles({
            ...defaultFilterUserRoles.value,
            page: userRolesPagination.page - 1,
            size: userRolesPagination.rowsPerPage,
          }),
          queryUpdateRolePermissions({
            ...defaultFilterRolePermissions.value,
            page: rolePermissionsPagination.page - 1,
            size: rolePermissionsPagination.rowsPerPage,
          }),
          queryUpdateUserPermissions({
            ...defaultFilterUserPermissions.value,
            page: userPermissionsPagination.page - 1,
            size: userPermissionsPagination.rowsPerPage,
          }),
        ]);
      } finally {
        stopLoading();
      }
    };

    const tableRowClickUserRoles = (item) => {
      userIds = [];
      userRoleIds = [];
      siteIds = [];
      userIds.push(item.userAccountId);
      userRoleIds.push(item.userRoleId);
      siteIds.push(item.siteId);
      queryUpdateUserPermissions({
        ...defaultFilterUserPermissions.value,
        page: userPermissionsPagination.page - 1,
        size: userPermissionsPagination.rowsPerPage,
      });
    };

    const onBulkDeleteUserRoleIds = async (data) => {
      let Request: any = [];
      tableDataUserRoles.value
        .filter((obj) => data.includes(obj.webId))
        .map((role) => {
          Request.push({
            userId: role.userAccountId,
            userRoleId: role.userRoleId,
            siteId: role.siteId,
          });
        });
      await UserAPI.getInstance()
        .deleteUserSites(Request)
        .then((data) => {
          loadUserRoleData(selectedUserId.value);
        })
        .catch((err) => {
          console.error(err);
        });
      toast.success(deleteMsgOfuserRoleSite);
    };
    const bulkDeleteCustomPermissionTabel = async (permissions) => {
      const userPermissionIds = permissions
        .flat()
        .filter((permission) => permission.user_permission_id !== null)
        .map((permission) => permission.user_permission_id);
      await UserAPI.getInstance()
        .bulkDeleteUserPermissions(userPermissionIds)
        .then(() => {
          refreshListRolePermissions();
        })
        .catch((err) => {
          console.error(err);
        });
    };
    const siteUpdated = async (siteId) => {
      selectedSiteId.value = siteId;
      permissionIds.value = [];
      await UserAPI.getInstance()
        .getUserPermissionsByUserAndSiteIds(selectedUserId.value, siteId)
        .then((res) => {
          customPermisionsList.value = [];
          res.content.map((permissionsGroups: any) => {
            permissionsGroups.permissions.map((perms) => {
              customPermisionsList.value.push(perms);
            });
          });
        })
        .catch((err) => {
          console.error(err);
        });
    };

    const getSpecificPermissionFromList = (permission) => {
      return (
        customPermisionsList.value.filter(
          (cusPer) =>
            cusPer.permission_code == permission.permissionCode &&
            cusPer.web_id != null
        ).length > 0
      );
    };
    const getSpecificPermissionFromCustomList = (permission) => {
      for (const obj of tableDataRolePermissions.value) {
        if (obj.siteId == targetDataUserPermission.value["siteIds"]) {
          const foundPermission = obj.permissions.find(
            (perm) => perm.webId == permission.webId
          );
          if (foundPermission && foundPermission.user_permission_id) {
            return true;
          }
        }
      }
      return false;
    };
    const getPermissionBySequence = (permissions, sequence) => {
      return permissions.find((permis) => permis.sequence === sequence) || {};
    };
    const checkIfPermissionExistsInRole = (permission, rolePermissions) => {
      return (
        userPermissionsRoleBase.value.filter(
          (element) =>
            element.code ==
              (permission.permissionCode
                ? permission.permissionCode
                : permission.permission_code) &&
            element.siteId == rolePermissions.siteId
        ).length > 0
      );
    };

    const customForm = () => {
      permissionIds.value = [];
      let tempGroup = [...permissionGroups.value];
      permissionGroups.value = [];
      let modal = new Modal(
        document.getElementById(`kt_modal_assign_permission`) as HTMLElement
      );
      modal.show();
      setTimeout(function () {
        permissionGroups.value = tempGroup;
      }, 1);
    };

    const getClass = (role) => {
      let className = "bg-success";
      if (role == "Manager") {
        className = "bg-info";
      } else if (role == "User") {
        className = "bg-primary";
      } else if (role == "Admin") {
        className = "bg-success";
      }

      return className;
    };

    /** User Roles */
    const syncQueryUserRoles = async (
      params?: Record<string, number | string>
    ) => {
      queryUpdateUserRoles(params);
    };

    const getUsers = async (params?: Record<string, number | string>) => {
      try {
        // Get selected site IDs
        const siteIds = selectedSites.value.map((site) => Number(site.value));
        const usersData = await UserAPI.getInstance().getUserList({
          status: "ACTIVE",
          siteIds: siteIds.length > 0 ? siteIds.join(",") : undefined,
          ...params,
        });
        users.value = [...usersData.content];
        usersFilter.value = [...usersData.content];
        if (usersFilter.value.length > 0 && !selectedUserId.value) {
          selectedUserId.value = usersFilter.value[0].webId;
          loadUserRoleData(usersFilter.value[0].webId);
        }
        usersPagination.total = usersData.totalElements;
        usersPagination.rowsPerPage = usersData.size;
        usersPagination.page = ++usersData.number;
        return usersData.content;
      } catch (err) {
        console.error(err);
      }
    };

    const queryUpdateUserRoles = async (params?: any) => {
      startLoading();
      try {
        // loadingUserRoles.value = true;
        tableDataUserRoles.value = [];
        if (selectedUserId.value) {
          const siteIds = selectedSites.value.map((site) => Number(site.value));
          const userRoleData = await UserAPI.getInstance().getUserRoleWithSites(
            selectedUserId.value,
            {
              siteIds: siteIds.length > 0 ? siteIds.join(",") : undefined,
              ...params,
              startDate: params?.startDate === null ? [] : params?.startDate,
            }
          );
          selectUserName.value = userRoleData.content[0]?.name || "";
          const arrayOfRoleIds = userRoleData.content
            .filter((obj) => obj.roleId !== null)
            .map((obj) => obj.roleId);
          userPermissionsRoleBase.value =
            currentUser.value.permissionModels.flatMap((obj) =>
              obj.rolePermissionModels
                .filter((role) => arrayOfRoleIds.includes(role.roleId))
                .map((role) => ({
                  code: role.permissionCode,
                  roleId: arrayOfRoleIds.find((id) => id == role.roleId),
                  siteId: userRoleData.content.find(
                    (obj) =>
                      obj.roleId ==
                      arrayOfRoleIds.find((id) => id == role.roleId)
                  )?.siteId,
                }))
            );
          localPreferenceUserRoles.value = { ...params };
          tableDataUserRoles.value = [...userRoleData.content];
          tableDataUserPermissions.value = [];
          userRolesPagination.total = userRoleData.totalElements;
          userRolesPagination.rowsPerPage = userRoleData.size;
          userRolesPagination.page = ++userRoleData.number;
          return userRoleData.content;
        }
      } finally {
        // loadingUserRoles.value = false;
        stopLoading();
      }
    };
    const refreshListUserRoles = () => {
      showDeleteDialogUserRole.value = false;
      queryUpdateUserRoles({ ...localPreferenceUserRoles.value });
    };

    /** User Permissions */
    const syncQueryUserPermissions = async (
      params?: Record<string, number | string>
    ) => {
      queryUpdateUserPermissions(params);
    };

    const queryUpdateUserPermissions = async (
      params?: Record<string, number | string>
    ) => {
      try {
        // loadingUserPermissions.value = true;
        startLoading();
        // const siteIds = selectedSites.value.map((site) => Number(site.value));
        const userPermissionsData =
          await UserAPI.getInstance().getUserPermissionsByIds(
            userIds,
            siteIds.length > 0 ? siteIds : [],
            userRoleIds,
            {
              ...params,
            }
          );
        if (userPermissionsData.content.length > 0) {
          openToggel.value = true;
        }
        localPreferenceUserPermissions.value = { ...params };
        const tableUserPermissions = prepareDataForTable([
          ...userPermissionsData.content,
        ]);

        const filteredTableUserPermissions = tableUserPermissions.filter(
          (item) =>
            item.permissions &&
            Array.isArray(item.permissions) &&
            item.permissions.some((perm) => perm.web_id !== null)
        );

        tableDataUserPermissions.value = filteredTableUserPermissions;
        userPermissionsPagination.total = userPermissionsData.totalElements;
        userPermissionsPagination.rowsPerPage = userPermissionsData.size;
        userPermissionsPagination.page = ++userPermissionsData.number;
      } finally {
        // loadingUserPermissions.value = false;
        stopLoading();
      }
    };
    const checkPermission = (type, permissions) => {
      return (
        permissions.filter((obj) => obj.permission_code.includes(type)).length >
        0
      );
    };

    const checkCustomPermission = (exists) => {
      if (exists == true) {
        return exists;
      }
    };

    const isChecked = (type, permissions) => {
      let checked = false;
      permissions.map((per) => {
        if (per.permission_code.includes(type)) {
          if (per.user_permission_id != null) {
            checked = true;
          }
        }
      });
      return checked;
    };

    let formData = ref<IAddEditFormModel>({
      header: t("pages.user.userPermission"),
      edit: false,
      data: null,
      label: [
        { addHeader: t("pages.user.addUserPermission") },
        { editHeader: t("pages.user.editUserPermission") },
      ],
      validationSchema: Yup.object({
        siteIds: Yup.string()
          .nullable()
          .required(t("pages.user.site") + " " + t("common.isRequired")),
      }),
      model: [
        {
          name: "siteIds",
          label: t("common.sites"),
          type: "list",
          required: false,
          showOnlyInEdit: false,
          disabled: false,
          placeholder: t("pages.user.selectSite"),
          options: siteOptions,
          multiSelect: false,
        },
        {
          name: "permissionIds",
          label: t("pages.user.permissions"),
          type: "custom",
          required: true,
        },
      ],
    });

    let roleFormData = ref<IAddEditFormModel>({
      header: "User Role",
      edit: false,
      data: null,
      label: [
        { addHeader: t("pages.user.addUserRole") },
        { editHeader: t("pages.user.editUserRole") },
      ],
      validationSchema: Yup.object({
        siteIds: Yup.array()
          .nullable()
          .min(1, t("pages.user.site") + " " + t("common.isRequired"))
          .required(t("pages.user.site") + " " + t("common.isRequired")),
        roleIds: Yup.string()
          .nullable()
          .required(t("pages.user.role") + " " + t("common.isRequired")),
      }),
      model: [
        {
          name: "siteIds",
          label: t("common.sites"),
          type: "list",
          required: true,
          showOnlyInEdit: false,
          disabled: false,
          placeholder: t("pages.user.selectSite"),
          options: siteOptions,
          multiSelect: true,
        },
        {
          name: "roleIds",
          label: t("pages.user.role"),
          type: "list",
          required: true,
          showOnlyInEdit: false,
          disabled: false,
          placeholder: t("pages.user.selectRole"),
          options: roleOptions,
          multiSelect: false,
        },
      ],
    });

    const updatePermission = async (type, customPermissions) => {
      let permission = customPermissions.permissions.filter((per) =>
        per.permission_code.includes(type)
      )[0];
      if (permission.user_permission_id == null) {
        let data = {
          userId: selectedUserId.value,
          siteId: customPermissions.siteId,
          permissionId: permission.webId,
        };
        await UserAPI.getInstance()
          .createUserPermissions(data)
          .then(() => {
            refreshListRolePermissions();
          })
          .catch((err) => {
            console.error(err);
          });
      } else {
        await UserAPI.getInstance()
          .deleteUserPermissions(permission.user_permission_id)
          .then(() => {
            refreshListRolePermissions();
          })
          .catch((err) => {
            console.error(err);
          });
      }
    };

    const prepareDataForTable = (data) => {
      data.map((obj) => {
        obj.read =
          obj.permissions?.filter((per) =>
            per?.permission_code?.includes(":READ")
          )?.length > 0;
        obj.create =
          obj.permissions.filter((per) =>
            per?.permission_code?.includes(":CREATE")
          )?.length > 0;
        obj.update =
          obj.permissions.filter((per) =>
            per?.permission_code?.includes(":UPDATE")
          )?.length > 0;
        obj.delete =
          obj.permissions.filter((per) =>
            per?.permission_code?.includes(":DELETE")
          )?.length > 0;
      });
      return data;
    };

    const prepareDataForRolePermissionTable = (data) => {
      data.map((obj) => {
        obj.read =
          obj.permissions?.filter((per) =>
            per.permission_code.includes(":READ")
          ).length > 0;
        obj.create =
          obj.permissions?.filter((per) =>
            per.permission_code.includes(":CREATE")
          ).length > 0;
        obj.update =
          obj.permissions?.filter((per) =>
            per.permission_code.includes(":UPDATE")
          ).length > 0;
        obj.delete =
          obj.permissions?.filter((per) =>
            per.permission_code.includes(":DELETE")
          ).length > 0;
      });
      return data;
    };

    const refreshListUserPermissions = () => {
      showDeleteDialogUserPermission.value = false;
      queryUpdateUserPermissions({
        ...localPreferenceUserPermissions.value,
      });
    };

    let permissionModel = ref<any>({
      create: "VYZOR:USERS:USER PERMISSIONS:CREATE",
      delete: "VYZOR:USERS:USER PERMISSIONS:DELETE",
      update: "VYZOR:USERS:USER PERMISSIONS:UPDATE",
    });

    /** Custom Permissions */
    const syncQueryRolePermissions = async (
      params?: Record<string, number | string>
    ) => {
      queryUpdateRolePermissions(params);
    };

    const deleteUserPermission = (userPermission) => {
      showDeleteDialogUserPermission.value = true;
      selectedForActionUserPermissions.value = userPermission;
      selectedUserPermissions.value = userPermission.permissions
        .map((obj) => {
          if (obj.user_permission_id != null) {
            return obj.user_permission_id;
          } else {
            return null;
          }
        })
        .filter((id) => id != null);
    };

    const deleteUserRole = (userRole) => {
      showDeleteDialogUserRole.value = true;
      selectedForActionUserRoles.value = userRole;
      selectedUserRoles.value = userRole;
    };

    const queryUpdateRolePermissions = async (
      params?: Record<string, number | string>
    ) => {
      try {
        // loadingRolePermissions.value = true;
        startLoading();
        if (selectedUserId.value) {
          const siteIds = selectedSites.value.map((site) => Number(site.value));
          if (!params || !params.sort) {
            params = {
              ...params,
              sort: "createdDate,desc",
            };
          }
          tableDataRolePermissions.value = [];
          const rolePermissionsData =
            await UserAPI.getInstance().getUserPermissionsById(
              selectedUserId.value,
              {
                siteIds: siteIds.length > 0 ? siteIds.join(",") : undefined,
                ...params,
              }
            );
          localPreferenceRolePermissions.value = { ...params };
          tableDataRolePermissions.value = prepareDataForRolePermissionTable([
            ...rolePermissionsData.content,
          ]);
          rolePermissionsPagination.total = rolePermissionsData.totalElements;
          rolePermissionsPagination.rowsPerPage = rolePermissionsData.size;
          rolePermissionsPagination.page = ++rolePermissionsData.number;
        }
      } finally {
        // loadingRolePermissions.value = false;
        stopLoading();
      }
    };
    const refreshListRolePermissions = () => {
      queryUpdateRolePermissions({ ...localPreferenceRolePermissions.value });
    };

    const submitUserRoles = async (data) => {
      const permissionData = [] as any;

      /****** Waqas said to change the multi-role to a single role. *****/

      data.siteIds.map((siteId) => {
        permissionData.push({
          siteId: parseInt(siteId),
          userAccountId: selectedUserId.value,
          roleId: parseInt(data.roleIds),
        });
      });
      await UserAPI.getInstance()
        .createUserRoleWithSites(permissionData)
        .then(() => {
          loadUserRoleData(selectedUserId.value);
        })
        .catch((err) => {
          console.error(err);
        });
    };
    const submitUserPermissions = (data) => {
      // TODO
    };

    const searchUsers = () => {
      if (usersSearchTerm.value != "") {
        usersFilter.value = [];
        users.value.map((user) => {
          if (
            user.firstName
              .toLowerCase()
              .includes(usersSearchTerm.value.toLowerCase()) ||
            user.lastName
              .toLowerCase()
              .includes(usersSearchTerm.value.toLowerCase()) ||
            user.email
              .toLowerCase()
              .includes(usersSearchTerm.value.toLowerCase())
          ) {
            usersFilter.value.push(user);
          }
        });
      } else {
        usersFilter.value = [];
        usersFilter.value = [...users.value];
      }
    };

    const submitRolePermissions = async () => {
      targetDataUserPermission.value["permissionIds"] = permissionIds.value;
      targetDataUserPermission.value.userIds = [];
      targetDataUserPermission.value.userIds.push(selectedUserId.value);
      targetDataUserPermission.value.permissionIds =
        targetDataUserPermission.value.permissionIds.map((obj) => {
          return parseInt(obj);
        });
      targetDataUserPermission.value.siteIds = [
        targetDataUserPermission.value.siteIds,
      ];
      if (targetDataUserPermission.value["permissionIds"].length > 0) {
        await UserAPI.getInstance()
          .assigbUserPermissions(targetDataUserPermission.value)
          .then(async () => {
            refreshListRolePermissions();
            selectedSiteId.value = undefined;
          })
          .catch((err) => {
            console.error(err);
          })
          .finally(() => {
            discard();
            toast.success(addMsgOfCustomPermission);
          });
      }
      if (customPermissionsToBeDeleted.value.length > 0) {
        await UserAPI.getInstance()
          .bulkDeleteUserPermissions(customPermissionsToBeDeleted.value)
          .then(() => {
            refreshListRolePermissions();
            selectedSiteId.value = undefined;
          })
          .catch((err) => {
            console.error(err);
          })
          .finally(() => {
            discard();
            toast.success(deleteMsgOfCustomPermission);
          });
      }
      targetDataUserPermission.value.siteIds = [];
      formRef?.value?.resetForm();
      discard();
    };

    const discard = () => {
      targetDataUserPermission.value.siteIds = undefined;
      selectedSiteId.value = undefined;
      permissionIds.value = [];
      formRef?.value?.resetForm();
      hideModal(hideModalRef.value);
      nextTick(() => {
        formRef?.value?.resetForm();
      });
    };

    const onFilterChange = (filters) => {
      activeFilter.value =
        Object.keys(filters).filter((item) => {
          if (
            (Array.isArray(filters[item]) && !filters[item]?.length) ||
            !filters[item] ||
            filters[item] === null
          ) {
            return false;
          }
          return true;
        }).length ?? 0;
      const localFilters = Object.keys(filters)
        .filter((key) => {
          const lookup =
            (tableFilter.value &&
              tableFilter.value.findIndex(
                (tab) => tab.key === key && tab.type === "lookup"
              )) ??
            -1;
          if (lookup > -1) {
            return !filters[key].includes("-1");
          }
          return true;
        })
        .reduce((filter, key) => {
          filter[key] = filters[key];
          return filter;
        }, {});
      getUsers({
        ...localPreference.value,
        page: 0,
        size: rowsPerPage,
        ...localFilters,
        sort: "createdDate,desc",
      });
    };
    const openRoleCollapse = ref(true);
    const toggleRoleCollapse = () => {
      openRoleCollapse.value = !openRoleCollapse.value;
    };
    const beforeEnter = (el) => {
      el.style.height = "0";
      el.style.opacity = "0";
    };
    const enter = (el) => {
      el.style.transition = "height 0.35s ease, opacity 0.35s ease";
      el.style.height = el.scrollHeight + "px";
      el.style.opacity = "1";
    };
    const afterEnter = (el) => {
      el.style.height = "auto";
      el.style.transition = "";
    };
    const beforeLeave = (el) => {
      el.style.height = el.scrollHeight + "px";
      el.style.opacity = "1";
    };
    const leave = (el) => {
      el.style.transition = "height 0.35s ease, opacity 0.35s ease";
      // Force reflow
      void el.offsetHeight;
      el.style.height = "0";
      el.style.opacity = "0";
    };
    const afterLeave = (el) => {
      el.style.transition = "";
    };
    const resetFilters = async () => {
      defaultFilterUsers.value = {};
      activeFilter.value = 0;
      usersSearchTerm.value = "";
      await getUsers({
        page: 0,
        size: usersPagination.rowsPerPage,
        sort: "createdDate,desc",
      });
    };

    const setItemsPerPage = async () => {
      startLoading();
      try {
        await getUsers({
          ...localPreference.value,
          page: 0,
          size: usersPagination.rowsPerPage,
          ...defaultFilterUsers.value,
          sort: "createdDate,desc",
        });
      } finally {
        stopLoading();
      }
    };
    const currentPageChange = async (page: number) => {
      startLoading();
      try {
        usersPagination.page = page;
        await getUsers({
          page: page - 1,
          size: usersPagination.rowsPerPage,
          ...localPreference.value,
          ...defaultFilterUsers.value,
          sort: "createdDate,desc",
        });
      } finally {
        stopLoading();
      }
    };
    // Watch for changes in selectedSites
    watch(
      selectedSites,
      async (newSites) => {
        if (newSites.length === 0) {
          resetFilters();
        } else {
          await getUsers({
            ...localPreference.value,
            ...defaultFilterUsers.value,
            page: 0,
            size: usersPagination.rowsPerPage,
            sort: "createdDate,desc",
          });
        }
      },
      { deep: true }
    );

    return {
      users,
      defaultFilterUsers,
      bulkDeleteUserRoles,
      format,
      tableDataUserRoles,
      tableHeaderUserRoles,
      tableFilterUserRoles,
      showSearchUserRoles,
      userRolesPagination,
      defaultFilterUserRoles,
      loadingUserRoles,
      selectedForActionUserRoles,
      syncQueryUserRoles,
      refreshListUserRoles,
      queryUpdateUserRoles,
      t,
      bulkDeleteUserPermissions,
      tableDataUserPermissions,
      tableHeaderUserPermissions,
      tableFilterUserPermissions,
      showSearchUserPermissions,
      userPermissionsPagination,
      defaultFilterUserPermissions,
      loadingUserPermissions,
      selectedForActionUserPermissions,
      syncQueryUserPermissions,
      refreshListUserPermissions,
      queryUpdateUserPermissions,
      bulkDeleteRolePermissions,
      tableDataRolePermissions,
      tableHeaderRolePermissions,
      tableFilterRolePermissions,
      showSearchRolePermissions,
      rolePermissionsPagination,
      defaultFilterRolePermissions,
      loadingRolePermissions,
      selectedForActionRolePermissions,
      syncQueryRolePermissions,
      refreshListRolePermissions,
      loadUserRoleData,
      permissionModel,
      hasPermission,
      getClass,
      checkPermission,
      isChecked,
      updatePermission,
      selectedUserPermissions,
      deleteUserPermission,
      formDataUserRoles,
      formDataUserPermissions,
      submitUserRoles,
      submitUserPermissions,
      tableRowClickUserRoles,
      customForm,
      updatePermissionForRole,
      permissionGroups,
      Field,
      ErrorMessage,
      Form,
      formData,
      targetDataUserPermission,
      formRef,
      loading,
      roleFormData,
      submitRolePermissions,
      formDataRolePermissions,
      deleteUserRole,
      onBulkDeleteUserRoleIds,
      searchUsers,
      usersFilter,
      usersSearchTerm,
      tableFilter,
      onFilterChange,
      activeFilter,
      pagination,
      selectedUserId,
      queryUpdateRolePermissions,
      discard,
      hideModalRef,
      showDeleteDialogUserRole,
      showDeleteDialogUserPermission,
      getSpecificPermissionFromList,
      checkCustomPermission,
      siteUpdated,
      selectedSiteId,
      userPermissionsRoleBase,
      currentUser,
      checkIfPermissionExistsInRole,
      selectUserName,
      openToggel,
      getPermissionBySequence,
      bulkDeleteCustomUser,
      bulkDeleteCustomPermissionTabel,
      customPermisionsList,
      getSpecificPermissionFromCustomList,
      openRoleCollapse,
      toggleRoleCollapse,
      beforeEnter,
      enter,
      afterEnter,
      beforeLeave,
      leave,
      afterLeave,
      selectedSites,
      getUsers,
      resetFilters,
      usersPagination,
      currentPageChange,
      setItemsPerPage,
      PAGE_ITEM,
      loadingCounter,
      pageIsLoading,
      startLoading,
      stopLoading,
    };
  },
});
